import React, { useEffect, useState } from "react";
import { FaAngleRight } from "react-icons/fa6";

type ProfileCardProps = {
  icon: JSX.Element;
  right_icon?: JSX.Element;
  value: string;
  onChange?: (newValue: string) => void;
  onClick?: () => void;
  hideRightArrow?: boolean;
  isDisabled?: boolean;
  /** Extra classes on the outer row */
  className?: string;
};

const ReusableProfileCard: React.FC<ProfileCardProps> = ({
  icon,
  right_icon,
  value,
  onChange,
  onClick,
  hideRightArrow = false,
  isDisabled = false,
  className = "",
}) => {
  const [isEditing, setIsEditing] = useState(false);
  const [inputValue, setInputValue] = useState(value);

  useEffect(() => {
    setInputValue(value);
  }, [value]);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setInputValue(e.target.value);
    if (onChange) onChange(e.target.value);
  };

  return (
    <div
      className={`flex cursor-pointer items-center justify-between gap-3 px-4 py-3.5 active:bg-black/[0.04] dark:active:bg-white/[0.06] ${className}`}
      onClick={() => {
        if (!isEditing && !isDisabled) {
          setIsEditing(true);
        }
        if (onClick) onClick();
      }}
    >
      <div className="flex min-w-0 flex-1 items-center gap-3">
        <span className="shrink-0 text-themeColor [&_svg]:block">{icon}</span>
        {isEditing && !isDisabled ? (
          <input
            type="text"
            value={inputValue}
            autoFocus
            onChange={handleInputChange}
            onBlur={() => setIsEditing(false)}
            className="min-w-0 flex-1 border-none bg-transparent text-[15px] text-darkText outline-none"
          />
        ) : (
          <div className="truncate text-[15px] text-darkText">{inputValue}</div>
        )}
      </div>
      {!hideRightArrow && (
        <span className="shrink-0 text-lightText">
          {right_icon ? right_icon : <FaAngleRight className="text-sm opacity-60" />}
        </span>
      )}
    </div>
  );
};

export default ReusableProfileCard;
